import { useContext } from "react";
import AuthContext from "./AuthContext";

const useIsUserInitialized = (): boolean => {
  const { isContextInitialized } = useContext(AuthContext);
  return isContextInitialized;
};

export default useIsUserInitialized;